import { faPlusCircle, faInfoCircle, faSpinner } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Container, Button, Modal, Form, ModalHeader, ModalBody, ModalFooter, FormGroup, Input, Label } from 'reactstrap';
import { bindActionCreators, Dispatch } from 'redux';
import { ApplicationState } from '../../../store';
import * as ConsoleStore from '../../../store/Console';
import { Application } from '../../../store/Console';
import { getUserApplicationShortcuts, addUpdateUserApplicationShortcuts, getCompanyUrlListByType } from '../../../ApiUtils/ApiUtils';
import { UserProfileContext } from '../ConsoleLayout';
import { CompanyUrl } from '../../Management/CompanyUrlsForm';


type QuickStartProps = {} & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class QuickStart extends React.Component<QuickStartProps, any> {
    static contextType = UserProfileContext;
    constructor(props: QuickStartProps) {
        super(props);
        this.state = {
            showModal: false,
            selectedShortcuts: [],
            displayedShortcuts: [],
            selectedUrlShortcuts: [],
            displayedUrlShortcuts: [],
            urlShortcuts: [],
            isSaving: false,
            isLoading: false,
            showAllShortcuts: false,
            companyUrlList: [],
        };
    }

    async componentDidMount() {
        try {
            this.setState({ isLoading: true });
            const response = await getUserApplicationShortcuts();
            const applications = this.props.console?.applicationsState.applications || [];
            
            const urlList = await Promise.all(
                applications
                    .filter((app: any) => app.urlType)
                    .map(async (app: any) => this.addShortcutIdOnUrlList(app))
            ).then((res) => {
                this.setState({ companyUrlList: res.flat() });
                return res.flat();
            });
              
            if (urlList && response.data.shortcuts?.shortcutIds) {
                const shortcutIds = response.data.shortcuts.shortcutIds.split(",").map((val: string) => val.trim());
                
                this.setState({
                    selectedShortcuts: shortcutIds,
                    displayedShortcuts: shortcutIds
                });

                if (response.data.shortcuts?.urlShortcutIds) {
                    const urlShortcutIds = response.data.shortcuts.urlShortcutIds.split(",").map((val: string) => val.trim());

                    this.setState({
                        selectedUrlShortcuts: urlShortcutIds,
                        displayedUrlShortcuts: urlShortcutIds
                    })
                    
                    this.setState({ urlShortcuts: urlList.filter((i:CompanyUrl) => urlShortcutIds.includes(i.id.toString())) })
                }
                
            }

            this.setState({ isLoading: false });
        } catch (ex) {
            this.setState({ isLoading: false });
            console.error("Error retrieving shortcuts: " + ex);
        }
    }

    private handleModalToggle = () => {
        this.setState((prevState: any) => ({
            showModal: !prevState.showModal
        }));
    };

    private handleCheckboxChange = (shortcutId?: string, isUrl: boolean = false) => {
        if (!shortcutId) return;

        if (isUrl) {
            this.setState({ selectedUrlShortcuts: (
                this.state.selectedUrlShortcuts.includes(shortcutId)
                    ? this.state.selectedUrlShortcuts.filter((id: string) => id !== shortcutId)
                    : [...this.state.selectedUrlShortcuts, shortcutId]
            )});
            return;
        }

        this.setState({ selectedShortcuts: (
            this.state.selectedShortcuts.includes(shortcutId)
                ? this.state.selectedShortcuts.filter((id: string) => id !== shortcutId)
                : [...this.state.selectedShortcuts, shortcutId]
        )});
    };

    private handleSave = async () => {
        try {
            this.setState({ isSaving: true, isLoading: true });

            let userEmail = this.props.console?.userProfileState.userProfile.email as string;
            await addUpdateUserApplicationShortcuts(
                userEmail,
                this.state.selectedShortcuts.join(","),
                this.state.selectedUrlShortcuts.join(",")
            );

            const applications = this.props.console?.applicationsState.applications || [];

            await Promise.all(
                applications
                    .filter(app => app.urlType && this.state.selectedShortcuts.includes(app.shortcutId))
                    .map(async (app) => (this.addShortcutIdOnUrlList(app)))
            ).then((results) => {
                this.setState({
                    displayedShortcuts: this.state.selectedShortcuts,
                    urlShortcuts: results.flat(),
                    displayedUrlShortcuts: this.state.selectedUrlShortcuts,
                    showModal: false,
                    isSaving: false,
                    isLoading: false
                });
            })
        } catch (ex) {
            this.setState({ isSaving: false });
            console.error("Error saving shortcuts: " + ex);
        }
    };

    private onLaunch = (event: React.MouseEvent, object: Application) => {
        event.preventDefault();
        this.props.consoleActions.launchApplication(object);
    }

    private getApplicationShortcuts = (applications: Application[]) => {
        return applications?.filter(app => app.display && app.type !== "PortalHome" && app.type !== "PortalAdmin").map(app => ({
            key: app.shortcutId,
            label: app.displayName,
            onClick: (e: any) => this.onLaunch(e, app)
        })) ?? []
    }

    private getUrlShortcuts = (urls: CompanyUrl[]) => {
         return urls.map((shortcut: CompanyUrl) => ({
              key: shortcut.url,
              label: shortcut.urlName,
              onClick: () => window.open(shortcut.url, '_blank')
          }))
    }

    private addShortcutIdOnUrlList = async (app: Application) => {
      return await getCompanyUrlListByType(this.context?.company, app.urlType!)
        .then((result) => {
          return result.data.companyUrls?.map((entry:CompanyUrl) => ({
            ...entry,
            shortcutId: app.shortcutId
          }))
        })
    }

    public render() {
        const { showModal, selectedShortcuts, displayedShortcuts, selectedUrlShortcuts } = this.state;
        const applications = this.props.console?.applicationsState.applications || [];

        const displayedApplicationShortcuts = applications?.filter((app:Application) =>
            app.shortcutId && displayedShortcuts.includes(app.shortcutId) && !app.urlType
        );

        const displayedUrlShortcuts = this.state.companyUrlList
          .filter((shortcut: CompanyUrl & { shortcutId: string }) => (
            this.state.displayedShortcuts.includes(shortcut.shortcutId) && 
            this.state.displayedUrlShortcuts.includes(shortcut.id.toString())
          ))

        return (
            <>
               <div className="d-flex align-items-center mb-2">
                    <h5 className="m-0 me-3">Quick Start</h5>

                    <FontAwesomeIcon
                        icon={faPlusCircle}
                        onClick={this.handleModalToggle}
                        className="quickstart-icon me-2"
                        title="Manage Quick Start"
                        size="lg"
                    />

                   <div className="info-icon-wrapper">
                    <FontAwesomeIcon
                        icon={faInfoCircle}
                        className="info-icon"
                        size="lg"
                    />
                    <div className="info-tooltip">
                        <strong>TIP:</strong> Click the (+) button on Quick Start to open the list of apps.
                        Toggle the switch beside each app to pin or unpin it.
                        Pinned apps stay at this section for easy access.
                    </div>
                    </div>

                    </div>


                {this.state.isLoading ? (
                    <div className="text-center d-flex justify-content-center align-items-center w-100">
                        <FontAwesomeIcon icon={faSpinner} size="2x" spin />
                    </div>
                ) : (
                    <div className="quickstartTabs">
                        {[ 
                            ...this.getApplicationShortcuts(displayedApplicationShortcuts),
                            ...this.getUrlShortcuts(displayedUrlShortcuts),
                        ]
                            .slice(0, this.state.showAllShortcuts ? undefined : 4)
                            .map((item, index) => (
                                <button
                                    key={item.key || index}
                                    className={`quickstartTab ${index === 0 ? 'active' : ''}`}
                                    onClick={item.onClick}
                                >
                                    {item.label}
                                </button>
                            ))}

                        {(displayedApplicationShortcuts?.length + displayedUrlShortcuts.length > 4) && (
                            <button
                                className="quickstartTab"
                                onClick={() =>
                                    this.setState((prev: any) => ({
                                        showAllShortcuts: !prev.showAllShortcuts
                                    }))
                                }
                            >
                                {this.state.showAllShortcuts ? 'Show Less...' : 'More...'}
                            </button>
                        )}
                    </div>
                )}

                <Modal
                    isOpen={showModal}
                    toggle={this.state.isSaving ? undefined : this.handleModalToggle}
                    backdrop={this.state.isSaving ? "static" : true}
                    keyboard={!this.state.isSaving}
                >
                    <ModalHeader toggle={this.state.isSaving ? undefined : this.handleModalToggle}>Manage Quick Start</ModalHeader>
                    <ModalBody>
                        <Form>
                            {applications?.filter(app => app.shortcutId).map((app) => (
                                <FormGroup check className="form-switch" key={app.shortcutId}>
                                    <Label check>
                                        <Input
                                            type="switch"
                                            checked={selectedShortcuts.includes(app.shortcutId)}
                                            onChange={() => this.handleCheckboxChange(app.shortcutId)}
                                            disabled={this.state.isSaving}
                                            style={{ backgroundColor: "#F62459" }}
                                        />
                                        {app.group} - {app.displayName}
                                    </Label>
                                    {(app.type === "DecisionStudio" ||
                                        app.type === "CaseManager") &&
                                        selectedShortcuts.includes(app.shortcutId) && (
                                        this.state.companyUrlList
                                          .filter((companyUrl: CompanyUrl & {shortcutId: string}) => companyUrl.shortcutId === app.shortcutId)
                                          .map((urlShortcut: CompanyUrl) => {
                                            let urlShortcutId = urlShortcut.id.toString()
                                            return <FormGroup check className="form-switch" key={urlShortcutId}>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        checked={selectedUrlShortcuts.includes(urlShortcutId)}
                                                        onChange={() => this.handleCheckboxChange(urlShortcutId, true)}
                                                        disabled={this.state.isSaving}
                                                        style={{ backgroundColor: "#F62459" }}
                                                    />
                                                    {urlShortcut.urlName}
                                                </Label>
                                            </FormGroup>
                                          })
                                    )}
                                </FormGroup>
                            ))}
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.handleModalToggle} disabled={this.state.isSaving}>
                            Close
                        </Button>
                        <Button color="primary" onClick={this.handleSave} disabled={this.state.isSaving}>
                            {this.state.isSaving ? (<span><span className="k-icon k-i-loading" style={{ marginRight: 8 }}></span>Saving...</span>) : ('Save')}
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        console: state.console,
        router: state.router
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path)),
        consoleActions: bindActionCreators(ConsoleStore.actionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuickStart);
